import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IGLAgingReportItem } from "./GLAgingReport.types";

export const FETCH_GL_AGING_REPORT_LIST_PROGRESS =
  "FETCH_GL_AGING_REPORT_LIST_PROGRESS";
export const FETCH_GL_AGING_REPORT_LIST_SUCCESS =
  "FETCH_GL_AGING_REPORT_LIST_SUCCESS";
export const FETCH_GL_AGING_REPORT_LIST_FAILED =
  "FETCH_GL_AGING_REPORT_LIST_FAILED";
export const CLEAR_GL_AGING_REPORT = "CLEAR_GL_AGING_REPORT";

export const fetchGLAgingReportListProgress = () =>
  action(FETCH_GL_AGING_REPORT_LIST_PROGRESS);
export const fetchGLAgingReportListSuccess = (
  data: IGLAgingReportItem[],
  totalRecords: number
) => action(FETCH_GL_AGING_REPORT_LIST_SUCCESS, { data, totalRecords });
export const fetchGLAgingReportListFailed = () =>
  action(FETCH_GL_AGING_REPORT_LIST_FAILED);
export const clearGLAgingReport = () => action(CLEAR_GL_AGING_REPORT);

export const fetchGLAgingReportListAsync =
  (
    asOfDate: string,
    glAccountCodeLike: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchGLAgingReportListProgress());
      const finalUrl = `/accounting/get-gl-ar-aging-report?as_of_date=${asOfDate}&gl_account_code_like=${glAccountCodeLike}`;

      const res = await api.get(finalUrl);
      const data: IGLAgingReportItem[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchGLAgingReportListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchGLAgingReportListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchGLAgingReportPdfAsync =
  (
    asOfDate: string,
    glAccountCodeLike: string,
    reportTitle: string,
    reportType: string,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(saveLoaderProgress());
      const finalUrl = `/accounting/get-gl-ar-aging-report-pdf?as_of_date=${asOfDate}&gl_account_code_like=${glAccountCodeLike}&type=${encodeURIComponent(reportType)}`;

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${reportTitle}_${asOfDate}.pdf`);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
